/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributesHolderIdentifier
 */
export interface AttributesHolderIdentifier {
    /**
     * 
     * @type {string}
     * @memberof AttributesHolderIdentifier
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof AttributesHolderIdentifier
     */
    type: string;
}

/**
 * Check if a given object implements the AttributesHolderIdentifier interface.
 */
export function instanceOfAttributesHolderIdentifier(value: object): value is AttributesHolderIdentifier {
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AttributesHolderIdentifierFromJSON(json: any): AttributesHolderIdentifier {
    return AttributesHolderIdentifierFromJSONTyped(json, false);
}

export function AttributesHolderIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributesHolderIdentifier {
    if (json == null) {
        return json;
    }
    return {
        
        'identifier': json['identifier'],
        'type': json['type'],
    };
}

export function AttributesHolderIdentifierToJSON(value?: AttributesHolderIdentifier | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identifier': value['identifier'],
        'type': value['type'],
    };
}

